import React from 'react'



const Header = () => {

        return (
          <div>
            <h1>High Score per Country</h1>
          </div>
        );
}

export default Header
